import Vue from 'vue';
import naverMap from 'vue-naver-maps';

Vue.use(naverMap, {
  clientID: 'eewn1r1ldw',
  useGovAPI: false, //공공 클라우드 API 사용 (선택)
  subModules:'drawing' // 서브모듈 (선택)
});

export default naverMap;
